export const getImageByType = (type?: string): string => {
  if (!type) return "/logoFgts.png";

  switch (type.toUpperCase()) {
    case "FGTS":
      return "/logoFgts.png";
    case "CREFAZ":
      return "/logoCrefaz.png";
    case "SALVCAR":
      return "/logoSalvcar.png";
    case "CREFISA":
      return "/logoCrefisa.jpg";
    case "PAN":
      return "/logoPan.png";
    case "CLT":
      return "/clt.svg";
    default:
      return "/logoFgts.png";
  }
};
